import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.widget.notice');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcuser-widget-notice',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.widget.notice/view.scss */
/* src/app/portal.gsdcuser.widget.notice/view.scss: no such file or directory */`],
})
export class PortalGsdcuserWidgetNoticeComponent implements OnInit {

    constructor(@Inject( Service) public service: Service) { }

    public notice: any = [];

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load");
        if (code != 200) return;
        this.notice = data;
        await this.service.render();
    }
}

export default PortalGsdcuserWidgetNoticeComponent;